<template>
  <div class="loading">
    <div class="loading__text">LOADING – NOG {{ this.resultsLeft }} MEER RESULTATEN</div>
    <div class="loading__background"></div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: ["resultsLeft"]
};
</script>

<style scoped>
.loading {
  position: fixed;
  bottom: 30px;
  left: 0;
  width: 80%;
  height: 30px;
  z-index: 15;
  margin-left: 20%;
}

.loading__text {
  display: inline-block;
  position: fixed;
  z-index: 6;
  margin-top: 3px;
  margin-left: 10px;
  font-family: "fl-mono", sans-serif;
  font-size: 1rem;
  color: #707070;
  background: white;
  padding: 3px 8px 3px 8px;
}

.loading__background {
  background: linear-gradient(90deg, #707070 50%, rgba(0, 0, 0, 0) 50%);
  background-size: 8px 8px;
  background-color: #000;
  height: 30px;
  -webkit-animation: focus 2s linear infinite;
}

@keyframes focus {
  from {
    background-position: 0 0, 0 0, 0 0, 0 0;
  }
  to {
    background-position: 24px 0, 24px 0, -24px 0, -24px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/results/Loading.vue